"use client"

import { WifiPen } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WifiPenIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WifiPenIcon = component(Icon)({ as: WifiPen })
